import axiosInstance from '../../api/axios';
import type { AuditEvent, AuditEventListParams, AuditEventsListResponse } from '../../admin/api/audit.api.ts';

export type ModuleAuditEventListParams = Omit<AuditEventListParams, 'organization_id' | 'resource_type'> & {
  /** Required. Must match a backend ResourceTypeToModule entry. */
  resource_type: string;
  /**
   * Optional narrowing within resource_type. `control_test_runs` (with resource_type test_execution):
   * only control-testing run events, not classic test executions.
   */
  scope?: string;
};

function buildModuleAuditQuery(params: ModuleAuditEventListParams): Record<string, string | number> {
  const query: Record<string, string | number> = {
    resource_type: params.resource_type.trim(),
  };
  if (params.scope?.trim()) query.scope = params.scope.trim();
  if (params.search?.trim()) query.search = params.search.trim();
  if (params.action?.trim()) query.action = params.action.trim();
  if (params.actor_user_id?.trim()) query.actor_user_id = params.actor_user_id.trim();
  if (params.from_date?.trim()) query.from_date = params.from_date.trim();
  if (params.to_date?.trim()) query.to_date = params.to_date.trim();
  if (params.page) query.page = params.page;
  if (params.page_size) query.page_size = params.page_size;
  return query;
}

/** Current-org audit events for one resource_type; server enforces module access. */
export async function fetchModuleAuditEvents(
  params: ModuleAuditEventListParams
): Promise<AuditEventsListResponse> {
  const { data } = await axiosInstance.get('/api/module-audit-events', {
    params: buildModuleAuditQuery(params),
  });
  return {
    events: Array.isArray(data?.events) ? data.events : [],
    pagination: data?.pagination ?? { page: 1, page_size: 20, total_items: 0, total_pages: 0 },
    counts: data?.counts ?? { total: 0, create: 0, update: 0, delete: 0 },
  };
}

export type { AuditEvent };
